import { lowerCase, normalizeAll, normalizeURL, noSpaces, trim } from '../lib/normalize';
import OptionListInput from '../OptionListInput';
import AddressInput from '../RegisterExtension/AddressInput';
import TermsInput from '../TermsInput';
import TextInput from '../TextInput';
import { address, cnpj, cpf, date, email, phone } from './validate';

export default {
  credentialName: {
    component: TextInput,
    props: {
      type: 'text',
    },
  },
  email: {
    component: TextInput,
    validator: email,
    props: {
      type: 'text',
      normalize: normalizeAll([lowerCase, trim]),
    },
  },
  address: {
    component: AddressInput,
    name: 'address',
    validator: address,
  },
  phone: {
    component: TextInput,
    halfWidth: true,
    validator: phone,
    props: {
      type: 'text',
      placeholder: '(00) 0000-0000',
    },
  },
  rg: {
    component: TextInput,
    halfWidth: true,
    props: {
      type: 'text',
    },
  },
  cpf: {
    component: TextInput,
    halfWidth: true,
    validator: cpf,
    props: {
      type: 'text',
      mask: '999.999.999-99',
      placeholder: '000.000.000-00',
    },
  },
  cnpj: {
    component: TextInput,
    halfWidth: true,
    validator: cnpj,
    props: {
      type: 'text',
      mask: '99.999.999/9999-99',
      placeholder: '00.000.000/0000-00',
    },
  },
  jobTitle: {
    component: TextInput,
    props: {
      type: 'text',
    },
  },
  companyName: {
    component: TextInput,
    props: {
      type: 'text',
    },
  },
  terms: {
    component: TermsInput,
  },
  checklist: {
    component: OptionListInput,
    hasOptions: true,
    props: {
      variant: 'checkbox',
    },
  },
  radiolist: {
    component: OptionListInput,
    hasOptions: true,
    props: {
      variant: 'radio',
    },
  },
  select: {
    component: TextInput,
    hasOptions: true,
    props: {
      variant: 'select',
    },
  },
  text: {
    component: TextInput,
    props: {
      type: 'text',
      variant: 'multiline',
    },
  },
  date: {
    component: TextInput,
    validator: date,
    props: {
      type: 'text',
      placeholder: 'DD/MM/AA',
      mask: '99/99/99',
    },
  },
  link: {
    component: TextInput,
    props: {
      type: 'text',
      placeholder: 'https://',
      normalize: normalizeAll([lowerCase, trim, noSpaces, normalizeURL]),
    },
  },
};



// WEBPACK FOOTER //
// ./src/site-render/src/lib/registerFormFieldTypes.js